import { Service } from '../Service';

class Admin extends Service {
    constructor(path) {
        super('/admin', path); // initial prefix
    }
}

export { Admin };